import React from 'react';
import { Helmet } from 'react-helmet';
import { useMetaTags } from '../utils/metatags';

const Head = (props) => {
  const metaTags = useMetaTags();

  return (
    <Helmet
      {...props}
      titleTemplate={`%s | ${metaTags.title}`}
      defaultTitle={metaTags.title}>
      {metaTags.title && <meta name="description" content="" />}
    </Helmet>
  );
};

export default Head;
